export var ChargeScopeEnum;
(function (ChargeScopeEnum) {
    ChargeScopeEnum["TOTAL"] = "total";
    ChargeScopeEnum["GROSS_TOTAL"] = "grossTotal";
    ChargeScopeEnum["SUB_TOTAL"] = "subtotal";
    ChargeScopeEnum["TOTAL_GRATUITY"] = "total_gratuity";
})(ChargeScopeEnum || (ChargeScopeEnum = {}));
//# sourceMappingURL=ChargeScopeEnum.js.map